import { Box, Svg, Text } from '@hopskipdrive/react-components';
import { colorPalette, colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

import { LocationDraft } from '../../types';

interface LocationCardProps {
  draft: LocationDraft;
  label?: string | null;
  onEdit: () => void;
}

export const LocationCard = ({ draft, label, onEdit }: LocationCardProps) => {
  const { location } = draft;
  const displayName = location.name || location.address;

  const handleNameClick = () => {
    window.open(`/locations/${location.id}`, '_blank');
  };

  return (
    <CardContainer>
      <Box display="flex" gap="9px" alignItems="flex-start" flex={1} minWidth={0} py="8px">
        <Box mt="2px" flexShrink={0}>
          <Svg height="16px" icon={location.locationType} />
        </Box>
        <Box display="flex" flexDirection="column" gap="4px" flex={1} minWidth={0}>
          <LocationNameButton onClick={handleNameClick} type="button" aria-label={displayName}>
            {displayName}
          </LocationNameButton>
          {label && (
            <InfoLabel>
              <Svg height="16px" icon="info" />
              <Text sx={{ fontSize: '12px', fontWeight: 500, color: colorTokens.text.dark }}>{label}</Text>
            </InfoLabel>
          )}
          {location.primary && (
            <Text sx={{ fontSize: '13px', fontWeight: 500, color: colorTokens.text.medium }}>Primary</Text>
          )}
          {location.name ? (
            <Text sx={{ fontSize: '13px', color: colorTokens.text.dark, textTransform: 'capitalize' }}>
              {location.address} · {location.locationType}
            </Text>
          ) : (
            <Text sx={{ fontSize: '13px', color: colorTokens.text.dark, textTransform: 'capitalize' }}>
              {location.locationType}
            </Text>
          )}
        </Box>
      </Box>
      <EditButton onClick={onEdit} aria-label="Edit location" type="button">
        <Svg height="16px" icon="edit-filled" color={colorTokens.text.medium} />
      </EditButton>
    </CardContainer>
  );
};

const CardContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 19px;
  border: 1px solid #cbd1d6;
  border-radius: 10px;
  background: #ffffff;
  width: 100%;
`;

const InfoLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: ${colorPalette.blue98};
  padding: 5px 16px;
  border-radius: 4px;
  width: 100%;
`;

const LocationNameButton = styled.button`
  font-size: 13px;
  font-weight: 500;
  color: ${colorTokens.primary.main};
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 2px;
  }
`;

const EditButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  flex-shrink: 0;

  &:hover {
    background: #ddebfa;
  }
`;
